import {StyleSheet} from 'react-native';
import {FONTS} from '../../../utils/Constants';

// Theme-aware styles factory (docs/DARK-MODE.md).
const makeStyles = colors =>
  StyleSheet.create({
    borderedButton: {
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 16,
      borderWidth: 2,
      borderColor: colors.link,
      paddingHorizontal: 12,
      minHeight: 52,
    },
    filledButton: {
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: colors.link,
      borderRadius: 16,
      paddingHorizontal: 8,
    },
    titleStyle: {
      fontSize: 18,
      fontFamily: FONTS.regularFont,
      marginVertical: 16,
    },
    buttonContainer: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    op07: {
      opacity: 0.7,
    },
  });

export default makeStyles;
